<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('changeAccount.irktProfili')" />
      <div class="row">
        <div
          v-if="companyDetails"
          class="col-xl-12 "
        >
          <div class="row">
            <div class="col-xl-7">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        id="fileInput"
                        ref="file"
                        type="file"
                        style="display: none"
                        @change="setPhoto"
                      >

                      <img
                        :src="getPhoto(companyDetails.logo,'mediumCropped')"
                        alt=""
                        class="img-thumbnail rounded-circle w-100"
                      >

                      <div
                        v-if="!hasAdmin || isAdmin"
                        class="mt-2 text-center"
                      >
                        <button
                          class="btn btn-sm mr-2 btn-outline-primary px-2"
                          @click="selectPhoto"
                        >
                          <feather
                            type="upload"
                            size="16"
                          />
                        </button>
                        <button
                          v-if="user.photo"
                          class="btn btn-sm mr-2 btn-outline-danger px-2"
                          @click.prevent="removeProfilePhoto"
                        >
                          <feather
                            type="trash"
                            size="16"
                          />
                        </button>

                        <div
                          v-if="uploadProgress >0 && uploadProgress <100"
                          class="progress"
                        >
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            aria-valuenow="75"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            :style="{width: `${uploadProgress}%`}"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9">
                      <div>
                        <div class="lead font-weight-bold">
                          {{ companyDetails.name }}
                          {{ getCompanyFormat(companyDetails.format) }}
                        </div>
                        <div
                          v-if="companyDetails.legalForm === 'JURIDICAL_PERSON'"
                          class="text-secondary"
                        >
                          {{ $t('companyProfile.hquqiXs') }}
                        </div>
                        <div
                          v-if="companyDetails.legalForm === 'INDIVIDUAL'"
                          class="text-secondary"
                        >
                          {{ $t('companyProfile.fizikiXs') }}
                        </div>
                      </div>
                      <hr>
                      <div v-if="companyDetails.legalForm!=='PERSONAL'">
                        <div class="text-secondary">
                          {{ $t('companyProfile.ven') }}
                        </div>
                        <div class="lead">
                          {{ companyDetails.taxId }}
                        </div>
                      </div>
                      <div v-else>
                        <div class="lead">
                          {{ $t('companyProfile.frdiXsProfili') }}
                        </div>
                      </div>
                      <hr>

                      <div
                        v-if="companyDetails.legalForm!=='PERSONAL'"
                        class="d-flex justify-content-between"
                      >
                        <div>
                          <div class="text-secondary">
                            {{ $t('companyProfile.nvan') }}
                          </div>
                          <div class="lead">
                            <span v-if="companyDetails.address">{{ companyDetails.address }}</span>
                            <a
                              v-else-if="!hasAdmin || isAdmin"
                              href="#"
                              @click.prevent="changeCompanyAddress()"
                            >
                              {{ $t('companyProfile.nvanLavEt') }}
                            </a>
                          </div>
                        </div>
                        <div v-if="companyDetails.address && (!hasAdmin || isAdmin)">
                          <a
                            href="#"
                            @click.prevent="changeCompanyAddress()"
                          >
                            <feather type="edit-2" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <UserCompanyAdminDetails />
                </div>
              </div>


              <div
                v-if="companyDetails.legalForm!=='PERSONAL'"
                class="mt-5"
              >
                <h3>{{ $t('companyProfile.irktProfillri') }}</h3>

                <div class="card">
                  <div class="card-header">
                    <a
                      v-for="k in Object.keys(profiles)"
                      :key="k"
                      class="btn m-2"
                      :class="[activeProfile===k?'btn-primary':'btn-outline-primary']"
                      aria-current="true"
                      href="#"
                      @click.prevent="activeProfile = k"
                    >
                      {{ getProfileName(k) }}
                    </a>
                  </div>

                  <div v-if="activeProfile !==''">
                    <div class="card-body">
                      <h4>{{ $t('companyProfile.profili', {getProfileName: getProfileName(activeProfile)}) }}</h4>
                      <p>
                        {{ $t('companyProfile.irktinHrMvcudBirBiznesProfiliZrHmBiznesReytinqiVAk') }}
                      </p>

                      <div v-if="activeProfile ==='SUPPLIER'">
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i
                            v-if="x <= companySupplyRating "
                            class="fa fa-3x fa-star text-warning"
                          />
                          <i
                            v-else
                            class="fa fa-3x fa-star-o text-secondary"
                          />
                        </span>

                        <span class="h2 ml-3 text-warning">{{ companySupplyRating || '0.0' }}</span>
                      </div>
                      <div v-else-if="activeProfile ==='PROCUREMENT'">
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i
                            v-if="x <= companyProcurementRating"
                            class="fa fa-3x fa-star text-warning"
                          />
                          <i
                            v-else
                            class="fa fa-3x fa-star-o text-secondary"
                          />
                        </span>

                        <span class="h2 ml-3 text-warning">{{ companyProcurementRating || '0.0' }}</span>
                      </div>
                      <div v-else>
                        <span
                          v-for="x in 5"
                          :key="x"
                          class="d-inline-block"
                        >
                          <i class="fa fa-3x fa-star-o text-secondary" />
                        </span>

                        <span class="h2 ml-3 text-warning">0.0</span>
                      </div>
                    </div>
                    <div class="card-body">
                      <CompanyRateStatistics
                        :company-id="company.id"
                        :profile-type="activeProfile"
                      />
                    </div>
                    <hr>
                    <div class="card-body">
                      <div v-if="editProfileIsOpen">
                        <form @submit.prevent="saveProfile">
                          <div class="row">
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyPage.telefon') }}</label>

                              <VuePhoneNumberInput
                                v-model="editingProfile.phone"
                                :default-country-code="'AZ'"
                                :only-countries="['AZ']"
                                :required="true"
                                :no-example="true"
                                @update="numberUpdated($event)"
                              />
                            </div>
                            <div class="col-6 mb-3">
                              <label>E-mail *</label>
                              <input
                                v-model="editingProfile.email"
                                type="email"
                                class="form-control"
                                required
                              >
                            </div>
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyPage.websayt') }}</label>
                              <input
                                v-model="editingProfile.website"
                                type="text"
                                class="form-control"
                              >
                            </div>
                            <div class="col-6 mb-3">
                              <label>{{ $t('companyProfile.linkedin2') }}</label>
                              <input
                                v-model="editingProfile.linkedin"
                                type="text"
                                class="form-control"
                              >
                            </div>
                          </div>

                          <div class="mb-3">
                            <button
                              type="submit"
                              class="btn btn-primary mr-2"
                            >
                              {{ $t('sectorSelectionModal.yaddaSaxla') }}
                            </button>
                            <a
                              class="btn btn-outline-primary  "
                              @click.prevent="editProfileIsOpen = false"
                            >
                              {{ $t('companyProfile.lvEt2') }}
                            </a>
                          </div>
                        </form>
                      </div>
                      <div v-else>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.telefon') }}</strong> <br>
                          <em>{{ companyActiveProfileData.phone || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.email') }}</strong> <br>
                          <em>{{ companyActiveProfileData.email || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.websayt') }}</strong> <br>
                          <em>{{ companyActiveProfileData.website || '-' }}</em>
                        </p>
                        <p class="lead">
                          <strong class="font-weight-bold">{{ $t('companyProfile.linkedin') }}</strong> <br>
                          <em>{{ companyActiveProfileData.linkedin || '-' }}</em>
                        </p>

                        <p v-if="!hasAdmin || isAdmin">
                          <button
                            class="btn btn-outline-primary"
                            @click.prevent="editProfileIsOpen= true"
                          >
                            {{ $t('companyProfile.mlumatlarDzliEt') }}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-5">
              <div class="card">
                <div
                  v-if="editWorkingSectors"
                  class="card-body"
                >
                  <p class="lead">
                    {{ $t('companyProfile.faliyytSahsiniDyi') }}
                  </p>
                  <form @submit.prevent="saveWorkingSectors">
                    <div
                      class="card"
                      style="background: #dddddd"
                    >
                      <div class="card-body">
                        <SelectedSectorView
                          :sectors="selectedSectors"
                          :parent-id="0"
                        />

                        <div class="mt-3">
                          <a
                            v-b-modal.modal-sector-selection
                            class="btn btn-primary"
                          >
                            {{ $t('companyProfile.faliyytSahsiniSein') }}
                          </a>
                        </div>
                      </div>
                    </div>


                    <div class="mb-3">
                      <button
                        type="submit"
                        class="btn btn-primary mr-2"
                      >
                        {{ $t('companyProfile.dyiikliyiYaddaSaxla') }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        @click.prevent="editWorkingSectors = false"
                      >
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  v-else
                  class="card-body"
                >
                  <SelectedSectorView
                    :sectors="sectors"
                    :parent-id="0"
                  />
                  <button
                    v-if="!hasAdmin || isAdmin"
                    class="btn btn-sm mt-2 btn-outline-primary d-flex align-items-center px-2"
                    @click.prevent="editWorkingSectors = true"
                  >
                    <feather
                      type="settings"
                      size="16"
                      class="mr-2"
                    />
                    {{ $t('companyProfile.faliyytSahlriniDyi') }}
                  </button>
                </div>
              </div>

              <div v-if="companyDetails.legalForm!=='PERSONAL'">
                <div class="mb-3">
                  <h3>{{ $t('dashboardCompany.irktIstifadilri') }}</h3>
                </div>

                <UserCompanyAdminDetails />

                <div
                  v-for="(u,i) in users"
                  :key="i"
                  class="card"
                  :class="{'bg-warning': isAdmin && u.status ==='new'}"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-3">
                        <img
                          class="rounded-circle img-fluid"
                          :src="getPhoto(u.user.photo,'mediumCropped')"
                          alt=""
                        >
                      </div>
                      <div class="col-7">
                        <h5>{{ u.user.name }} {{ u.user.surname }}</h5>
                        <h6>
                          <strong>{{ getProfileName(u.profileType) }}</strong>
                        </h6>
                        <p class="p-0 m-0">
                          {{ u.position }}
                        </p>
                        <span
                          v-if="u.status==='verified'"
                          class="badge bg-success"
                        >{{ $t('companyProfile.tsdiqlnmi') }}</span>
                        <span
                          v-else
                          class="badge bg-danger"
                        >{{ $t('companyProfile.tsdiqlnmmi') }}</span>
                        <span
                          v-if="adminUser && adminUser.id === u.user.id"
                          class="badge bg-primary ml-2"
                        >{{ $t('companyProfile.idari') }}</span>
                      </div>
                      <div
                        v-if=" isAdmin"
                        class="col-2"
                      >
                        <button
                          v-if="u.status!=='verified'"
                          type="button"
                          class="btn btn-sm btn-success px-3 mb-2"
                          @click="confirmUserProfile(u.id)"
                        >
                          <feather
                            type="check"
                            size="20"
                          />
                        </button>
                        <br>
                        <button
                          v-if="u.user.id !== user.id"
                          type="button"
                          class="btn btn-sm btn-danger  px-3"
                          @click="rejectUserProfile(u.id)"
                        >
                          <feather
                            type="x"
                            size="20"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-sector-selection"
      centered
      :title="$t('companyProfile.faliyytSahsiniSein')"
      scrollable
      class="theme-modal"
      :busy="false"
    >
      <sector_selection_modal
        :parent-sector="null"
        :selected="selectedSectors"
        :max-selection="20"
        @done="($event)=>{selectedSectors = $event; $bvModal.hide('modal-sector-selection') }"
      />

      <template #modal-footer>
        <div class="text-warning">
          {{ $t('companyProfile.siz20FaliyytSahsiSeBilrsiniz') }}
        </div>
      </template>
    </b-modal>
  </div>
  <!-- Container-fluid Ends-->
</template>
<script>
import {mapState} from "vuex";
import {
  changeCompanyDetail, changeCompanySectors, companyUserAction, getCompanyDetails, getCompanyProfiles,
  getCompanyUsers, removeCompanyLogo, saveProfile,
  updateCompanyLogo,
  upload,
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";

import CompanyRateStatistics from "@/pages/scc/company/CompanyRateStatistics.vue";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import UserCompanyAdminDetails from "@/pages/scc/account/UserCompanyAdminDetails.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    SelectedSectorView,
    UserCompanyAdminDetails,
    Sector_selection_modal,
    Sector_path,
    CompanyRateStatistics,
    Multiselect,
    VuePhoneNumberInput
  },
  data() {
    return {
      mediaBase: mediaBase,
      companyDetails: null,
      sectors: [],
      users: [],
      adminUser: null,
      profiles: {},
      uploadProgress: 0,
      activeProfile: '',
      allSectors: [],
      selectedSectors: [],
      editWorkingSectors: false,
      editProfileIsOpen: false,
      editingProfile: {},
      phoneNumberObject: null,
      companyActiveProfileData: null,

    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      hasAdmin: state => state.auth.hasAdmin,
      isAdmin: state => state.auth.isAdmin,
    }),
    companySupplyRating() {
      if (!this.companyDetails || this.companyDetails.supplyRateCount === null || this.companyDetails.supplyRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.supplyRateTotal / this.companyDetails.supplyRateCount).toFixed(1);
      }
    },
    companyProcurementRating() {
      if (!this.companyDetails || this.companyDetails.procurementRateCount === null || this.companyDetails.procurementRateCount < 1) {
        return 0;
      } else {
        return (this.companyDetails.procurementRateTotal / this.companyDetails.procurementRateCount).toFixed(1);
      }
    }
  },
  watch: {
    editWorkingSectors(newVal) {
      if (newVal) {
        this.selectedSectors = this.sectors;
        this.phoneNumberObject = null;
      }
    },
    activeProfile(newVal) {
      this.editProfileIsOpen = false;
      this.companyActiveProfileData = this.profiles[newVal]
    },
    editProfileIsOpen(newVal) {
      if (newVal) {
        this.editingProfile = {...(this.profiles[this.activeProfile])};
      } else {
        this.editingProfile = {};
      }
    },
    profiles: {
      handler(newData) {
        console.log('profiles handled');
        console.log(newData[this.activeProfile]);
        if (newData[this.activeProfile]) {
          this.companyActiveProfileData = newData[this.activeProfile]
        }
      },
      deep: true
    }
  },
  mounted() {

    this.getCompanyDetails();
    this.getCompanyUsers();
    this.getCompanyProfiles();

  },
  methods: {

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getCompanyDetails() {
      getCompanyDetails(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          this.companyDetails = data.company;
          this.sectors = data.sectors;
          this.selectedSectors = data.sectors;
        } else {
          this.$router.push({name: 'changeAccount'});
        }
      })
    },
    getCompanyUsers() {
      getCompanyUsers(this.token).then(data => {
        if (data.code === 200) {
          this.users = data.users;
          this.adminUser = data.adminUser;
        }
      })
    },
    getCompanyProfiles() {
      getCompanyProfiles(this.token, this.company.id).then(data => {
        if (data.code === 200) {
          data.profiles.forEach(p => {
            this.profiles[p.profileType] = JSON.parse(p.profileData);
          })
          if (this.activeProfile === '' && data.profiles.length > 0) {
            this.activeProfile = data.profiles[0].profileType;
          } else {
            this.companyActiveProfileData = this.profiles[this.activeProfile]
          }
        }
      })
    },
    changeCompanyAddress() {
      this.$swal({
        title: this.$t("zhmtOlmsYnUnvn"),
        input: 'text',
        icon: 'question',
        inputValue: this.companyDetails.address,
      }).then((result) => {
        if (result.value) {
          changeCompanyDetail(this.token, 'address', result.value).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("unvnUdlrDysdrl"),
                icon: 'success'
              }).then(() => {
                this.getCompanyDetails();
              })

            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }

      })

    },
    confirmUserProfile(id) {
      this.$swal({
        title: this.$t("prflTsdqEtmkIstdyn"),
        icon: 'question',
      }).then((result) => {

        if (result.value) {
          companyUserAction(this.token, id, 'verify', '').then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("istfdCPrflTsqd"),
                icon: 'success'
              }).then(() => {
                this.getCompanyUsers();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        }
      })
    },
    rejectUserProfile(id) {
      this.$swal({
        title: this.$t("prflLgvTmkUchn"),
        icon: 'question',
        input: 'textarea'
      }).then((result) => {

        if (result.value) {
          companyUserAction(this.token, id, 'reject', '').then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("istdfcPrflSlnd"),
                icon: 'success'
              }).then(() => {
                this.getCompanyUsers();
              })
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          })
        } else {
          alert(this.$t("sbbDxlEtmkVcbd"));
        }
      })
    },

    saveWorkingSectors() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      changeCompanySectors(this.token, sectors).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("flyytShlrDyshdrld"),
            icon: 'success'
          }).then(() => {
            this.editWorkingSectors = false;
            this.getCompanyDetails();
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },

    removeProfilePhoto() {
      if (confirm(this.$t("sklSlmkIstdyndn"))) {
        removeCompanyLogo(this.token).then(data => {
          if (data.code === 200) {
            this.getCompanyDetails();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'profilePhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                updateCompanyLogo(this.token, response.data.path).then(data => {
                  if (data.code === 200) {
                    this.getCompanyDetails();
                  } else {
                    this.$swal({
                      title: `Error ${data.code}`,
                      text: `${data.message}`,
                      icon: 'error'
                    })
                  }
                })

              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              console.log(e);
              this.progress = 0;
              this.$swal({
                title: `Error `,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    saveProfile() {
      if (!this.phoneNumberObject || !this.phoneNumberObject.isValid) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("nmrnDzgnDxlDn"),
          icon: 'warning'
        })
      } else {

        let data = {
          phone: this.phoneNumberObject.e164,
          email: this.editingProfile.email,
          website: this.editingProfile.website,
          linkedin: this.editingProfile.linkedin
        };

        saveProfile(this.token, this.companyDetails.id, JSON.stringify(data), this.activeProfile).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("unvnUdlrDysdrl"),
              icon: 'success'
            }).then(() => {
              this.getCompanyProfiles();
              this.editProfileIsOpen = false;
            });
          } else {
            console.log(data);
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }
        })
      }
    },

    numberUpdated(p) {
      this.phoneNumberObject = p;
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
